import { useEffect, useState } from "react";
import { LabeledIntArray } from "../../../models";
import { ReportService } from "../../../services/SubmissionService";
import ReactApexChart from "react-apexcharts";
import { Card, CardContent } from "@mui/material";

export default function FilingReportWidget() {
    const [monthlyReport, setMonthlyReport] = useState([] as LabeledIntArray[]);
    useEffect(() => {
        ReportService.getMonthly({ attorneyId: "" }).then(
            (resp) => {
                setMonthlyReport(resp);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);
    return (
        <Card sx={{ width: "100%" }}>
            <CardContent>
                <div className="dropdown float-end">
                    <a
                        href="#"
                        className="dropdown-toggle arrow-none card-drop"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i className="mdi mdi-dots-horizontal"></i>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                        <a href="javascript:void(0);" className="dropdown-item">
                            Hour
                        </a>
                        <a href="javascript:void(0);" className="dropdown-item">
                            Day
                        </a>
                        <a href="javascript:void(0);" className="dropdown-item">
                            Week
                        </a>
                        <a href="javascript:void(0);" className="dropdown-item">
                            Month
                        </a>
                    </div>
                </div>
                <h4 className="header-title">Filing Report</h4>
                <div className="mt-3 text-center">
                    <div dir="ltr">
                        <div id="chart" data-colors="#526dee,#e3eaef">
                            <ReactApexChart
                                options={{
                                    chart: {
                                        height: 265,
                                        type: "bar",
                                        stacked: true,
                                        toolbar: {
                                            show: false,
                                        },
                                    },
                                    plotOptions: {
                                        bar: {
                                            horizontal: false,
                                            columnWidth: "25%",
                                        },
                                    },
                                    dataLabels: {
                                        enabled: false,
                                    },
                                    stroke: {
                                        show: true,
                                        width: 2,
                                        colors: ["transparent"],
                                    },
                                    legend: {
                                        show: false,
                                    },
                                    colors: ["#727cf5", "#18c984", "#f672a7"],
                                    xaxis: {
                                        categories:
                                            monthlyReport.length > 0
                                                ? monthlyReport.map(
                                                      (d) => d.name
                                                  )
                                                : "",
                                        axisBorder: {
                                            show: false,
                                        },
                                    },
                                    yaxis: {
                                        labels: {
                                            formatter: function (val) {
                                                return val + "";
                                            },
                                            offsetX: -15,
                                        },
                                    },
                                    fill: {
                                        opacity: 1,
                                    },
                                    tooltip: {
                                        y: {
                                            formatter: function (val) {
                                                return val + "";
                                            },
                                        },
                                    },
                                }}
                                series={[
                                    {
                                        name: "Existing",
                                        data: monthlyReport.map(
                                            (d) => d.value![0]
                                        ),
                                    },
                                    {
                                        name: "New",
                                        data: monthlyReport.map(
                                            (d) => d.value![1]
                                        ),
                                    },
                                    {
                                        name: "Service",
                                        data: monthlyReport.map(
                                            (d) => d.value![2]
                                        ),
                                    },
                                ]}
                                type="bar"
                                height={350}
                            />
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
